import { useState, useContext, useEffect } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import Pagination from "../../components/Pagination";
import Search from '../../components/Search';
import ActivityTable from './ActivityTable';

const Activity = () => {
  const { activityData, activityFilterData, setActivityFilterData } = useContext(GlobalContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [selectedIds, setSelectedIds] = useState([]);
  const [fileCount, setFileCount] = useState(0);
  const [totalWords, setTotalWords] = useState(0);

  const filteredData = activityFilterData || [];
  const [currentPosts, setCurrentPosts] = useState([]);

  // Update currentPosts on page or data change
  useEffect(() => {
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    setCurrentPosts(filteredData.slice(indexOfFirstPost, indexOfLastPost));
  }, [filteredData, currentPage, postsPerPage]);

  const howManyPages = Math.ceil(filteredData.length / postsPerPage);

  const showAlert = (message) => {
    alert(message); // You can replace this with toast
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds(prev => {
      const alreadySelected = prev.includes(id);
      const newSelection = alreadySelected
        ? prev.filter(selectedId => selectedId !== id)
        : [...prev, id];

      showAlert(alreadySelected ? "Unchecked file." : "File selected.");
      return newSelection;
    });
  };

  const handleSelectAll = () => {
    const currentPageIds = currentPosts.map(item => item.id);
    const allSelected = currentPageIds.every(id => selectedIds.includes(id));

    setSelectedIds(prev => {
      const updatedIds = allSelected
        ? prev.filter(id => !currentPageIds.includes(id))
        : [...new Set([...prev, ...currentPageIds])];

      return updatedIds;
    });
  };

  const checkAll = () => {
    const allIds = filteredData.map(item => item.id);
    const allSelected = allIds.every(id => selectedIds.includes(id));

    if (allSelected) {
      setSelectedIds([]);
      showAlert("✅ All files unchecked.");
    } else {
      setSelectedIds(allIds);
      showAlert("✅ All files selected.");
    }
  };

  const handleRemoveText = (indexToRemove) => {
    setSelectedIds(prev =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  useEffect(() => {
    let wordsCount = 0;
    const selectedSet = new Set(selectedIds);
    const dataMap = new Map(filteredData.map(item => [item.id, item]));

    selectedSet.forEach(id => {
      const item = dataMap.get(id);
      if (item) wordsCount += parseInt(item.wordcounts || 0);
    });

    setTotalWords(wordsCount);
    setFileCount(selectedSet.size);
  }, [selectedIds, filteredData]);

  useEffect(() => {
    setSelectedIds([]);
    setFileCount(0);
    setTotalWords(0);
  }, [activityFilterData]);

  return (
    <>
      <div className="container mb-5">
        <div className="mb-1 mt-2">
          <div className="row">
            <div className="col-md-6">
              <Search data={activityData} setFilterData={setActivityFilterData} />
            </div>
            <div className="col-md-6 mt-2">
              <div>
                <span className="border bg-primary text-white mx-3 p-2 link_text">
                  File: {fileCount}
                </span>
                <span className="border bg-primary text-white p-2 link_text">
                  Words Count: {totalWords}
                </span>
                <button
                  className="btn btn-sm btn-outline-primary ms-3"
                  onClick={checkAll}
                >
                  ✅ Check All
                </button>
              </div>
            </div>
          </div>
        </div>

        <div>
          <ActivityTable
            currentPosts={currentPosts}
            setCurrentPosts={setCurrentPosts} // ✅ Pass setter correctly
            handleCheckboxChange={handleCheckboxChange}
            selectedIds={selectedIds}
            handleSelectAll={handleSelectAll}
          />
        </div>
      </div>

      <div className="text-md-right">
        <div className="d-flex justify-content-between">
          <div className="ml-5">
            <label htmlFor="">Jump to</label>
            <select
              className="mx-2"
              style={{ width: "50px", height: "30px" }}
              value={postsPerPage}
              onChange={(e) => {
                setPostsPerPage(parseInt(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
            <span>Page {currentPage} of {howManyPages}</span>
          </div>
          <div className="mx-5 mb-5">
            <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Activity;
